export default {
    saveStoreInfo: function (state, storeInfo) {
        state.storeInfo = storeInfo;
    },
    initQueryParams: function (state, data) {
        state.queryParams = data;
    },
}